export default "__VITE_ASSET__JOBiwmGu__"